import React, { Component } from 'react';
import axios from 'axios';

import Thanks from '../../../components/Thanks';
import Input, { Textarea } from '../../../components/forms/input';
import Head from 'next/head';

class CustomProposal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
      platforms: [],
      step: props.step,
      activePlan: props.activePlan,
      showSocialMedias: false,
      c1: null,
      c2: null,
      c3: null,
      socialMediaUrls: [
        {
          id: 'url_1',
        },
      ],
      competitorsWebsite: [
        {
          id: 'website_1',
        },
      ],
      otherMainGoal: false,
      plannedMonthlyBudget: false,
      platformsArr: [],
      req: false,
      activePlans: [],
      plan: {},
    };
    this.myRef = React.createRef();
    this.platforms = React.createRef();
    this.name = React.createRef();
    this.email = React.createRef();
    this.cName = React.createRef();
    this.cNamecWebsite = React.createRef();
    this.handleChange = this.handleChange.bind(this);

    this.hideThanksModal = this.hideThanksModal.bind(this);

    this.onSubmit = this.onSubmit.bind(this);
  }
  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({ step: nextProps.step });
    this.setState({ activePlan: nextProps.activePlan });
  }

  handleChange(param, value) {
    var formdata = this.state.formdata;

    if (param == 'have-existing-social-media') {
      if (document.querySelector('[name=have-existing-social-media]').checked) this.setState({ showSocialMedias: true });
      else this.setState({ showSocialMedias: false });
    }
    if (param == 'platform') {
      let checkboxes = document.getElementsByName('platform');
      let checkboxesChecked = [];
      for (let i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          checkboxesChecked.push(checkboxes[i].value);
        }
      }
      if (checkboxesChecked.length >= 1) {
        this.setState({ platforms: checkboxesChecked });
      } else {
        this.setState({ platforms: [] });
      }
    }

    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  }
  hideThanksModal() {
    this.setState({
      loadedThanks: false,
      showThanks: false,
    });
    document.body.style.overflow = 'auto';

    document.body.style.overflowX = 'hidden';
  }
  onSubmit(e) {
    e.preventDefault();

    var that = this;

    var form_data = new FormData();

    // social-media-pages
    let urlsSMM = [];
    document.querySelectorAll('[name=social-media-pages]').forEach(el => {
      urlsSMM.push(el.value);
    });

    // competitors-website
    let urlsComp = [];
    document.querySelectorAll('[name=competitors-website]').forEach(el => {
      urlsComp.push(el.value);
    });

    for (var key in this.state.formdata) {
      form_data.append(key, Array.isArray(this.state.formdata[key]) ? this.state.formdata[key].join(' , ') : this.state.formdata[key]);
    }

    form_data.append('country', this.props.country);
    form_data.append('platform', this.state.platforms.join(' , '));
    form_data.append('social-media-pages', urlsSMM.join(' , '));
    form_data.append('competitors-website', urlsComp.join(' , '));
    form_data.append('goals', this.state.activePlans.join(' , '));
    form_data.append('planned-monthly-budget', document.getElementById('planed').value);
    form_data.append('other-goal', document.getElementById('other-goal').value);

    if (this.state.plan) {
      form_data.append(
        'title',
        this.state.plan == 1
          ? 'SMM Social Start Plan Request for'
          : this.state.plan == 2
            ? 'SMM Advanced Plan Request for'
            : 'SMM Master Plan Request for'
      );
      form_data.append('currency', this.state.plan == 1 ? this.state.c1 : this.state.plan == 2 ? this.state.c2 : this.state.c3);
      form_data.append('pricing_package', this.state.plan == 1 ? 'SMM Social Start' : this.state.plan == 2 ? 'SMM Advanced ' : 'SMM Master');
    }

    // that.setState({showThanks:true});

    document.body.style.overflow = 'hidden';

    axios.post('https://mailer.weprodigi.com/api/v1/smm-custom-proposal', form_data).then(response => {
      window.location.href = 'https://weprodigi.com/thank-you';

      // that.setState({loadedThanks:true,req:false,platforms:[],activePlan:0,activePlans:[]});
      // document.getElementById('offer-form-smm-custom').reset();
      // document.body.style.overflow = 'auto';
    });
  }
  addSocialPackageInput = ind => {
    if (this.state.socialMediaUrls.length == ind + 1) {
      let elArr = Object.assign([], this.state.socialMediaUrls);
      elArr.push({
        id: 'url_' + (ind + 2),
      });
      this.setState({ socialMediaUrls: elArr });
    }
  };
  addCompetitorInput = ind => {
    if (this.state.competitorsWebsite.length == ind + 1) {
      let elArr = Object.assign([], this.state.competitorsWebsite);
      elArr.push({
        id: 'url_' + (ind + 2),
      });
      this.setState({ competitorsWebsite: elArr });
    }
  };
  setPlatformsCheckbox = (name, value) => {
    if (this.state.plan) {
      let l = this.state.plan == 1 ? 2 : this.state.plan == 2 ? 3 : 4;
      let arr = this.state.platforms;
      if (arr.length > l) {
        if (arr.includes(value)) {
          arr = arr.filter(function (val) {
            return val != value;
          });
          this.setState({ platforms: arr, req: false });
        }
      } else {
        if (!arr.includes(value)) {
          arr.push(value);
        } else {
          arr = arr.filter(function (val) {
            return val != value;
          });
        }
        this.setState({ platforms: arr, req: false });
      }
    } else {
      let arr = this.state.platforms;
      if (!arr.includes(value)) {
        arr.push(value);
      } else {
        arr = arr.filter(function (val) {
          return val != value;
        });
      }

      this.setState({ platforms: arr, req: false });
    }
  };
  setActivePlansCheckbox = (name, value) => {
    let arr = this.state.activePlans;
    if (!arr.includes(value)) {
      arr.push(value);
    } else {
      arr = arr.filter(function (val) {
        return val != value;
      });
    }

    this.setState({ activePlans: arr, req: false });
  };
  componentDidMount() {
    let href = window.location.search;
    let param = href.slice(1).split('&')[0].split('=')[1];
    this.setState({ platforms: param ? [param] : [] });

    let p = new URLSearchParams(document.location.search);
    this.setState({ plan: p.get('pl') });
    this.setState({ c1: p.get('c1') });
    this.setState({ c2: p.get('c2') });
    this.setState({ c3: p.get('c3') });
  }
  emailValidation = email => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email || regex.test(email) === false) {
      return false;
    }
    return true;
  };
  render() {
    const { step, showOther, activePlan, platforms, activePlans } = this.state;
    const l = this.props.plan ? (this.props.plan == 1 ? 2 : this.props.plan == 2 ? 3 : 4) : null;
    return (
      <>
        <style global jsx>
          {`
            input[type='text'],
            input[type='number'],
            textarea {
              font-size: 16px;
            }
            .disabled-class {
              pointer-events: none;
              opacity: 0.4;
            }
          `}
        </style>
        <Head>
          <title>SMM Services Request Form - Get a Proposal | Prodigi</title>
          <link rel="alternate" hrefLang="en" href="https://weprodigi.com/social-media-marketing/proposals/smm-custom-proposal" />
          <meta
            name="description"
            content="Request a custom social media marketing proposal from Prodigi. Let's create the best strategy to help you grow your social presence."
          />
          <meta property="og:url" content="https://weprodigi.com/social-media-marketing/proposals/smm-custom-proposal" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="SMM Services Request Form - Get a Proposal | Prodigi" />
          <meta
            property="og:description"
            content="Request a custom social media marketing proposal from Prodigi. Let's create the best strategy to help you grow your social presence."
          />
        </Head>
        <div className="py-23  container ">
          <h1 className="text-purple uppercase text-24 text-center font-black leading-none">SMM Custom Proposal</h1>
          <p className="text-black text-12 mt-20">
            In order to provide you with a custom and targeted SMM proposal, we need some information about your business and objectives. An email
            address is required in the form.
          </p>
          <form id="offer-form-smm-custom" method="POST" onSubmit={e => this.onSubmit(e)}>
            <div className={`mt-20 ${step == 1 ? 'block' : 'block'}`}>
              <p ref={this.cName} className={'text-16 text-purple font-bolder'}>
                Company Name*{' '}
                {this.state.req && !this.state.formdata['company-name'] && (
                  <span
                    className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                    style={{ verticalAlign: 'super' }}
                  >
                    This is required
                  </span>
                )}
              </p>
              <div className={'w-full mt-5'}>
                <Input type="text" name="company-name" bg="bg-white w-full focus:outline-none" required={true} onChange={this.handleChange} />
              </div>
              <p ref={this.cNamecWebsite} className={'text-16 text-purple font-bolder mt-20'}>
                Company Website*{' '}
                {this.state.req && !this.state.formdata['company-website'] && (
                  <span
                    className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                    style={{ verticalAlign: 'super' }}
                  >
                    This is required
                  </span>
                )}
              </p>
              <div className={'w-full mt-5'}>
                <Input type="text" name="company-website" bg="bg-white w-full focus:outline-none" required={true} onChange={this.handleChange} />
              </div>
              <p className={'text-16 text-purple font-bolder mt-20 leading-none'}>Do you have existing Social Media pages?</p>
              <div className={'flex justify-between mt-15'}>
                <div className="form-group   w-half">
                  <div className="radio-item">
                    <input
                      type="radio"
                      id="social-media-page"
                      name="have-existing-social-media"
                      value="Yes"
                      onChange={() => this.handleChange('have-existing-social-media', 'Yes')}
                    />
                    <label htmlFor="social-media-page">Yes</label>
                  </div>
                </div>
                <div className="form-group mr-5  ml-10 w-half">
                  <div className="radio-item">
                    <input
                      type="radio"
                      id="social-media-page-no"
                      name="have-existing-social-media"
                      value="No"
                      onChange={() => this.handleChange('have-existing-social-media', 'No')}
                    />
                    <label htmlFor="social-media-page-no">No</label>
                  </div>
                </div>
              </div>
              {this.state.showSocialMedias && (
                <div className="mt-20">
                  {this.state.socialMediaUrls.map((url, i) => {
                    return (
                      <input
                        type="text"
                        className={'mt-2 focus:outline-none rounded-5 py-5 px-10 w-full'}
                        data-key={i}
                        key={url.id}
                        name={'social-media-pages'}
                        placeholder={'Social Media page’s URL'}
                        onChange={() => this.addSocialPackageInput(i)}
                      />
                    );
                  })}
                </div>
              )}
            </div>
            <div className={`mt-20 ${step == 2 ? 'block' : 'block'}`}>
              <p ref={this.platforms} className={'text-16 text-purple validate-form flex flex-wrap items-center font-bolder'}>
                Please choose which platforms should be included in the SMM package?{' '}
                {this.state.req && platforms.length == 0 && (
                  <span
                    className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                    style={{ verticalAlign: 'super' }}
                  >
                    This is required
                  </span>
                )}{' '}
              </p>
              <div className={' justify-between'}>
                <input className={'input-hidden'} type="text" required={platforms.length == 0} />
                <div className="form-group mr-5  w-full">
                  <div className=" mt-10 mb-10">
                    <div
                      onClick={() => {
                        this.setPlatformsCheckbox('platforms', 'Facebook');
                      }}
                      className={`${platforms.includes('Facebook') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer ${l - 1 == platforms.length && !platforms.includes('Facebook') ? 'disabled-class' : ''}`}
                    >
                      <span className="text-16 leading-20">Facebook</span>
                      {platforms.includes('Facebook') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                    </div>
                  </div>
                  <div className="mb-10">
                    <div
                      onClick={() => {
                        this.setPlatformsCheckbox('platforms', 'Instagram');
                      }}
                      className={`${platforms.includes('Instagram') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer ${l - 1 == platforms.length && !platforms.includes('Instagram') ? 'disabled-class' : ''}`}
                    >
                      <span className="text-16 leading-20">Instagram</span>
                      {platforms.includes('Instagram') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                    </div>
                  </div>
                  <div className="mb-10">
                    <div
                      onClick={() => {
                        this.setPlatformsCheckbox('platforms', 'LinkedIn');
                      }}
                      className={`${platforms.includes('LinkedIn') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer ${l - 1 == platforms.length && !platforms.includes('LinkedIn') ? 'disabled-class' : ''}`}
                    >
                      <span className="text-16 leading-20">LinkedIn</span>
                      {platforms.includes('LinkedIn') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                    </div>
                  </div>
                  <div className="mb-10">
                    <div
                      onClick={() => {
                        this.setPlatformsCheckbox('platforms', 'Twitter');
                      }}
                      className={`${platforms.includes('Twitter') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer ${l - 1 == platforms.length && !platforms.includes('Twitter') ? 'disabled-class' : ''}`}
                    >
                      <span className="text-16 leading-20">Twitter</span>
                      {platforms.includes('Twitter') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                    </div>
                  </div>

                  <div className="mb-10">
                    <div
                      onClick={() => {
                        this.setPlatformsCheckbox('platforms', 'Youtube');
                      }}
                      className={`${platforms.includes('Youtube') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer ${l - 1 == platforms.length && !platforms.includes('Youtube') ? 'disabled-class' : ''}`}
                    >
                      <span className="text-16 leading-20">Youtube</span>
                      {platforms.includes('Youtube') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                    </div>
                  </div>
                </div>
                <div className="form-group mr-5    w-full">
                  <div className="mt-15 mb-10">
                    <div
                      onClick={() => {
                        this.setPlatformsCheckbox('platforms', 'Snapchat');
                      }}
                      className={`${platforms.includes('Snapchat') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer  ${l - 1 == platforms.length && !platforms.includes('Snapchat') ? 'disabled-class' : ''}`}
                    >
                      <span className="text-16 leading-20">Snapchat</span>
                      {platforms.includes('Snapchat') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                    </div>
                  </div>
                  <div className=" mb-10">
                    <div
                      onClick={() => {
                        this.setPlatformsCheckbox('platforms', 'Pinterest');
                      }}
                      className={`${platforms.includes('Pinterest') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer  ${l - 1 == platforms.length && !platforms.includes('Pinterest') ? 'disabled-class' : ''}`}
                    >
                      <span className="text-16 leading-20">Pinterest</span>
                      {platforms.includes('Pinterest') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                    </div>
                  </div>
                  <div className=" mb-10">
                    <div
                      onClick={() => {
                        this.setPlatformsCheckbox('platforms', 'TikTok');
                      }}
                      className={`${platforms.includes('TikTok') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer  ${l - 1 == platforms.length && !platforms.includes('TikTok') ? 'disabled-class' : ''}`}
                    >
                      <span className="text-16 leading-20">TikTok</span>
                      {platforms.includes('TikTok') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                    </div>
                  </div>
                  <div className=" mb-10">
                    <div
                      onClick={() => {
                        this.setPlatformsCheckbox('platforms', 'Recommend me');
                      }}
                      className={`${platforms.includes('Recommend me') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer  ${l - 1 == platforms.length && !platforms.includes('Recommend me') ? 'disabled-class' : ''}`}
                    >
                      <span className="text-16 leading-20">Recommend me</span>
                      {platforms.includes('Recommend me') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                    </div>
                  </div>
                </div>
              </div>

              <p className={'text-16 text-purple font-bolder mt-20'}>Some information about your target audience</p>
              <div className={'w-full mt-5'}>
                <Textarea
                  type="text"
                  placeholder={'Age, gender, target locations, interests and etc.'}
                  name="some-information"
                  bg="resize-none bg-white w-full focus:outline-none"
                  onChange={this.handleChange}
                />
              </div>
              <p className={'text-16 text-purple font-bolder mt-20'}>Please mention your competitors' websites or company names.</p>
              <div className="mt-20">
                {this.state.competitorsWebsite.map((url, i) => {
                  return (
                    <input
                      type="text"
                      className={'mt-2 focus:outline-none rounded-5 py-5 px-10 w-full'}
                      data-key={i}
                      key={url.id}
                      name={'competitors-website'}
                      placeholder={'Competitor’s website URL'}
                      onChange={() => this.addCompetitorInput(i)}
                    />
                  );
                })}
              </div>
              <div className="mt-10">
                <div className="grid grid-cols-1 gap-10">
                  <div>
                    <p className="text-16 text-purple font-bolder">What is your main goals for Social Media Marketing?</p>

                    <div className="mt-15 mb-10">
                      <div
                        onClick={() => {
                          this.setActivePlansCheckbox('activePlans', 'Increase brand awareness and visibility');
                        }}
                        className={`${activePlans.includes('Increase brand awareness and visibility') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                      >
                        <span className="text-16 leading-20">Increase brand awareness and visibility</span>
                        {activePlans.includes('Increase brand awareness and visibility') && (
                          <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />
                        )}
                      </div>
                    </div>
                    <div className="mb-10">
                      <div
                        onClick={() => {
                          this.setActivePlansCheckbox('activePlans', 'Get more engagement');
                        }}
                        className={`${activePlans.includes('Get more engagement') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                      >
                        <span className="text-16 leading-20">Get more engagement</span>
                        {activePlans.includes('Get more engagement') && (
                          <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />
                        )}
                      </div>
                    </div>
                    <div className="mb-10">
                      <div
                        onClick={() => {
                          this.setActivePlansCheckbox('activePlans', 'Get more sales');
                        }}
                        className={`${activePlans.includes('Get more sales') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                      >
                        <span className="text-16 leading-20">Get more sales</span>
                        {activePlans.includes('Get more sales') && (
                          <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />
                        )}
                      </div>
                    </div>
                    <div className="mb-10">
                      <div
                        onClick={() => {
                          this.setActivePlansCheckbox('activePlans', 'Increase traffic to your website');
                        }}
                        className={`${activePlans.includes('Increase traffic to your website') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                      >
                        <span className="text-16 leading-20">Increase traffic to your website</span>
                        {activePlans.includes('Increase traffic to your website') && (
                          <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />
                        )}
                      </div>
                    </div>
                    <div className="mb-10">
                      <div
                        onClick={() => {
                          this.setActivePlansCheckbox('activePlans', 'Other');
                        }}
                        className={`${activePlans.includes('Other') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                      >
                        <span className="text-16 leading-20">Other</span>
                        {activePlans.includes('Other') && <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />}
                      </div>
                    </div>
                    <div className="mb-10">
                      <input
                        type="text"
                        className={`mt-2 focus:outline-none rounded-5 py-5 px-10 w-full ${activePlans.includes('Other') ? 'block' : 'hidden'}`}
                        id={'other-goal'}
                        name={'other-goal'}
                        placeholder={'Your main goal'}
                        onChange={this.handleChange}
                      />
                    </div>
                    <p className={'text-16 text-purple font-bolder mt-20 leading-none'}>Do you have a planned monthly budget?</p>
                    <div className={'flex justify-between mt-15'}>
                      <div className="form-group    w-half">
                        <div className="radio-item">
                          <input
                            type="radio"
                            id="have-monthly-budget-no"
                            name="have-monthly-budget"
                            value="Yes"
                            onChange={() => {
                              this.handleChange('have-monthly-budget', 'Yes');
                              this.setState({ plannedMonthlyBudget: true });
                            }}
                          />
                          <label htmlFor="have-monthly-budget-no">Yes</label>
                        </div>
                      </div>
                      <div className="form-group mr-5  ml-10 w-half">
                        <div className="radio-item">
                          <input
                            type="radio"
                            id="have-monthly-budget"
                            name="have-monthly-budget"
                            value="No"
                            onChange={() => {
                              this.handleChange('have-monthly-budget', 'No');
                              this.setState({ plannedMonthlyBudget: false });
                            }}
                          />
                          <label htmlFor="have-monthly-budget">No</label>
                        </div>
                      </div>
                    </div>
                    {/*{this.state.plannedMonthlyBudget &&*/}
                    <div className="mt-20">
                      <input
                        type="text"
                        className={`mt-2 focus:outline-none rounded-5 py-5 px-10 w-full ${this.state.plannedMonthlyBudget ? 'block' : 'hidden'}`}
                        name={'planned-monthly-budget'}
                        id={'planed'}
                        placeholder={'Planned Monthly budget'}
                        onChange={this.handleChange}
                      />
                    </div>
                    {/*}*/}

                    <p className={'text-16 text-purple font-bolder mt-20'}>Other information you might want to share with us</p>
                    <div className={'w-full mt-5'}>
                      <Textarea
                        type="text"
                        placeholder={'Main Products Description, Project Deadlines and etc.'}
                        name="some-information-other"
                        bg="resize-none bg-white w-full focus:outline-none"
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`mt-20 ${step == 3 ? 'block' : 'block'}`}>
              <p ref={this.name} className={'text-16 text-purple font-bolder'}>
                Your Name *{' '}
                {this.state.req && !this.state.formdata['name'] && (
                  <span
                    className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                    style={{ verticalAlign: 'super' }}
                  >
                    This is required
                  </span>
                )}
              </p>
              <div className={'w-full mt-5'}>
                <Input type="text" name="name" bg="bg-white w-full focus:outline-none" required={true} onChange={this.handleChange} />
              </div>
              <p ref={this.email} className={'text-16 text-purple font-bolder mt-20'}>
                Your Email *
                {this.state.req && !this.state.formdata['email'] && (
                  <span
                    className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                    style={{ verticalAlign: 'super' }}
                  >
                    This is required
                  </span>
                )}
                {this.state.req && this.state.formdata['email'] && !this.emailValidation(this.state.formdata['email']) && (
                  <span
                    className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                    style={{ verticalAlign: 'super' }}
                  >
                    Email is not valid
                  </span>
                )}
              </p>
              <div className={'w-full mt-5'}>
                <Input type="email" name="email" bg="bg-white w-full focus:outline-none" required={true} onChange={this.handleChange} />
              </div>
              <p className={'text-16 text-purple font-bolder mt-20'}>Your Phone Number </p>
              <div className={'w-full mt-5'}>
                <Input type="text" name="phone" bg="bg-white w-full focus:outline-none" onChange={this.handleChange} />
              </div>
              <p className={'text-16 text-purple font-bolder mt-20 leading-none'}>What’s the best way to contact you?</p>
              <div className="flex flex-row mt-15">
                <div className="form-group mr-30">
                  <div className="radio-item">
                    <input
                      type="radio"
                      id="contact-via-email"
                      name="contact-via"
                      value="Email"
                      onChange={() => this.handleChange('contact-via', 'Email')}
                    />
                    <label htmlFor="contact-via-email">Email</label>
                  </div>
                </div>
                <div className="form-group mr-30">
                  <div className="radio-item">
                    <input
                      type="radio"
                      id="contact-via-phone"
                      name="contact-via"
                      value="Phone"
                      onChange={() => this.handleChange('contact-via', 'Phone')}
                    />
                    <label htmlFor="contact-via-phone">Phone</label>
                  </div>
                </div>
                <div className="form-group mr-30">
                  <div className="radio-item">
                    <input
                      type="radio"
                      id="contact-via-both"
                      name="contact-via"
                      value="Both"
                      onChange={() => this.handleChange('contact-via', 'Both')}
                    />
                    <label htmlFor="contact-via-both">Both</label>
                  </div>
                </div>
              </div>
              <p className="text-14 font-bolder text-black mt-15">Send NDA</p>
              <div className="flex flex-row my-10">
                <div className="form-group mr-30">
                  <div className="radio-item">
                    <input type="radio" id="nda" name="nda" value="Yes" onChange={() => this.handleChange('nda', 'Yes')} />
                    <label htmlFor="nda">Yes</label>
                  </div>
                </div>
                <div className="form-group mr-30">
                  <div className="radio-item">
                    <input type="radio" id="nda-no" name="nda" value="No" onChange={() => this.handleChange('nda', 'No')} />
                    <label htmlFor="nda-no">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div className={'mt-20 text-center'}>
              <button
                id={'offer-submit'}
                className={'text-white bg-purple rounded-5 px-20 py-5 capitalize'}
                onClick={e => {
                  let cName = this.state.formdata['company-name'];
                  let cWebsite = this.state.formdata['company-website'];
                  let name = this.state.formdata['name'];
                  let email = this.state.formdata['email'];
                  if (!cName || !cWebsite || !name || !email || platforms.length == 0 || !this.emailValidation(email)) {
                    this.setState({ req: true });
                    if (!name) this.name.current.scrollIntoView();
                    if (!email || !this.emailValidation(email)) this.email.current.scrollIntoView();
                    if (platforms.length == 0) this.platforms.current.scrollIntoView();
                    if (!cWebsite) this.cNamecWebsite.current.scrollIntoView();
                    if (!cName) this.cName.current.scrollIntoView();
                  } else {
                    this.setState({ req: false });
                    this.onSubmit(e);
                  }
                }}
                type="button"
              >
                submit
              </button>
            </div>
          </form>
        </div>

        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal} backUrl={'/social-media-marketing'}>
          One of our account managers will contact you and confirm your request. If you don’t receive an email from us within 24 hours please check
          your Spam Box.
        </Thanks>
      </>
    );
  }
}

export default CustomProposal;
